import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export function BenefitsSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <div className="flex flex-col md:flex-row items-center gap-16" data-id="element-3">
          <div className="w-full md:w-1/2 flex justify-center" data-id="element-4">
            <div className="bg-gradient-to-b from-[#f8f4ff] to-white rounded-3xl shadow-2xl p-8 w-full max-w-md border border-purple-100" data-id="element-5">
              <p className="text-center text-sm font-bold text-purple-700 uppercase tracking-widest mb-6" data-id="element-6">
                Tu transformación en 21 días
              </p>

              {/* Comparison rows */}
              <div className="space-y-3" data-id="element-7">
                {[{
                before: 'Abdomen inflamado al despertar',
                after: 'Abdomen plano y ligero'
              }, {
                before: 'Cansancio extremo todo el día',
                after: 'Energía real desde la mañana'
              }, {
                before: 'Ropa apretada en la cintura',
                after: 'Ropa ajustando mejor'
              }, {
                before: 'Digestión pesada e hinchazón',
                after: 'Digestión ligera y cómoda'
              }, {
                before: 'Ansiedad y mente nublada',
                after: 'Calma y claridad mental'
              }].map((item, i) => <div key={i} className="grid grid-cols-2 gap-2" data-id="element-8">
                    <div className="bg-red-50 border border-red-100 rounded-xl px-3 py-2.5 flex items-center gap-2" data-id="element-9">
                      <span className="text-red-400 text-base flex-shrink-0" data-id="element-10">
                        ✖
                      </span>
                      <span className="text-xs text-red-700 leading-tight" data-id="element-11">
                        {item.before}
                      </span>
                    </div>
                    <div className="bg-green-50 border border-green-100 rounded-xl px-3 py-2.5 flex items-center gap-2" data-id="element-12">
                      <span className="text-green-500 text-base flex-shrink-0" data-id="element-13">
                        ✓
                      </span>
                      <span className="text-xs text-green-700 leading-tight" data-id="element-14">
                        {item.after}
                      </span>
                    </div>
                  </div>)}
              </div>

              {/* Header labels */}
              <div className="grid grid-cols-2 gap-2 mt-4" data-id="element-15">
                <div className="text-center" data-id="element-16">
                  <span className="text-xs font-bold text-red-500 uppercase tracking-wide bg-red-50 border border-red-200 px-3 py-1 rounded-full" data-id="element-17">
                    ❌ Antes
                  </span>
                </div>
                <div className="text-center" data-id="element-18">
                  <span className="text-xs font-bold text-green-600 uppercase tracking-wide bg-green-50 border border-green-200 px-3 py-1 rounded-full" data-id="element-19">
                    ✅ Después
                  </span>
                </div>
              </div>

              <div className="mt-5 bg-purple-600 rounded-xl p-4 text-center" data-id="element-20">
                <p className="text-white text-sm font-semibold" data-id="element-21">
                  ✨ Sin dietas extremas · Sin gimnasio · 15 min/día
                </p>
              </div>
            </div>
          </div>

          <div className="w-full md:w-1/2" data-id="element-22">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 font-heading" data-id="element-23">
              En solo 21 días, notarás:
            </h2>

            <div className="space-y-8" data-id="element-24">
              <div className="flex" data-id="element-25">
                <div className="flex-shrink-0" data-id="element-26">
                  <CheckCircle2Icon className="h-8 w-8 text-green-500" data-id="element-27" />
                </div>
                <div className="ml-4" data-id="element-28">
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-29">
                    Tu ropa ajustando mejor
                  </h3>
                  <p className="mt-2 text-gray-600" data-id="element-30">
                    Especialmente en la zona de la cintura, donde el cortisol
                    suele acumular grasa.
                  </p>
                </div>
              </div>

              <div className="flex" data-id="element-31">
                <div className="flex-shrink-0" data-id="element-32">
                  <CheckCircle2Icon className="h-8 w-8 text-green-500" data-id="element-33" />
                </div>
                <div className="ml-4" data-id="element-34">
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-35">
                    Energía real al despertar
                  </h3>
                  <p className="mt-2 text-gray-600" data-id="element-36">
                    Despiértate renovada sin necesidad de esa taza de cafeína
                    inmediata para funcionar.
                  </p>
                </div>
              </div>

              <div className="flex" data-id="element-37">
                <div className="flex-shrink-0" data-id="element-38">
                  <CheckCircle2Icon className="h-8 w-8 text-green-500" data-id="element-39" />
                </div>
                <div className="ml-4" data-id="element-40">
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-41">
                    Digestión ligera
                  </h3>
                  <p className="mt-2 text-gray-600" data-id="element-42">
                    Adiós a la hinchazón después de comer. Siente tu abdomen
                    plano y tu rostro desinflamado.
                  </p>
                </div>
              </div>

              <div className="flex" data-id="element-43">
                <div className="flex-shrink-0" data-id="element-44">
                  <CheckCircle2Icon className="h-8 w-8 text-green-500" data-id="element-45" />
                </div>
                <div className="ml-4" data-id="element-46">
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-47">
                    Claridad mental
                  </h3>
                  <p className="mt-2 text-gray-600" data-id="element-48">
                    Recupera tu enfoque y olvídate de la neblina mental causada
                    por el estrés crónico.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-10 p-6 bg-purple-50 rounded-lg border border-purple-100" data-id="element-49">
              <p className="text-purple-800 font-medium text-lg italic text-center" data-id="element-50">
                "Es hora de dejar de pelear contra tu cuerpo y empezar a
                trabajar con él."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}